import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-modal";
import MealsStructure from "../../diet/meal/MealsStructure";
import { fetchAllPTStatsData } from "../../../redux/reducers/apiSlice";
import {
  getCardIcon,
  getCardLabel,
  getCardValue,
  objectToQueryString1,
} from "../../common-data/Conversions";
import CommonStatCard from "./CommonStatCard";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import PTFlowStatCardDetails from "./PTFlowStatCardDetails";
// import SelectExportables from "../../common-components/SelectExportables";
// import { taeeExportable } from "./users-info/calculations";
// import { fetchExportApiData } from "../../../redux/reducers/commonApiSlice";
// import { toast } from "react-toastify";
// import { exportTAEE } from "../../../data/ApiEndpoints";

const PT_MEMBERS_INFO_ORDER = [
  "total",
  "active",
  "expired",
  "expiring",
  "ongoing_session",
  "upcoming_session",
  "completed_session_today",
  "ongoing_session_expired",
];

const PTFlowStats = ({ userInfoData, prevAllFilters, prevFilters }) => {
  const dispatch = useDispatch();
  const { loading, allPTStatsData } = useSelector((state) => state.api);
  // const { exportData, exportLoading } = useSelector((state) => state.common);

  const initialPtStatsData = {
    ptPTMembersData: null,
    allSessionsData: null,
    allData: null,
  };
  const [allPTDatas, setAllPTDatas] = useState(initialPtStatsData);
  const iniModValues = {
    isModOpen: false,
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  // const [csvData, setCsvData] = useState();

  const finalFilters = { ...prevFilters };
  const CONVERTED_QP = finalFilters ? objectToQueryString1(finalFilters) : "";
  const finalQp = CONVERTED_QP ? `&${CONVERTED_QP}` : "";

  const isDateSelected = prevFilters.date_from && prevFilters.date_to;

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const onClickStatCard = (name) => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      modName: name,
    }));
  };

  function getAllPTStats(finalQp) {
    dispatch(
      fetchAllPTStatsData({
        queryParameters: finalQp,
        token: userInfoData?.token,
      })
    );
  }

  function combineReload() {
    getAllPTStats(finalQp);
  }

  // function getExportedData(filters) {
  //   dispatch(
  //     fetchExportApiData({
  //       method: "GET",
  //       endpoint: exportTAEE,
  //       payload: {
  //         filters: filters,
  //       },
  //       token: userInfoData?.token,
  //     })
  //   );
  // }

  // const onClickExport = (filters) => {
  //   if (filters.is_export) {
  //     getExportedData(filters);
  //   } else {
  //     toast.error("IS Export Not Found!");
  //   }
  // };

  useEffect(() => {
    getAllPTStats(finalQp);
  }, [finalQp]);

  useEffect(() => {
    if (allPTStatsData?.status) {
      setAllPTDatas((prevState) => {
        const newState = { ...prevState };

        const ptData = allPTStatsData?.data ? allPTStatsData.data : {};
        const sessionData = allPTStatsData?.session_stats
          ? allPTStatsData.session_stats
          : {};

        newState.allData = { ...ptData };

        Object.entries(sessionData).forEach(([key, value]) => {
          newState.allData[key] = value;
        });

        return newState;
      });
    } else {
      setAllPTDatas(initialPtStatsData);
    }
  }, [allPTStatsData]);

  // useEffect(() => {
  //   if (exportData) {
  //     setCsvData(exportData);
  //   } else {
  //     setCsvData();
  //   }
  // }, [exportData]);

  const sortedCards =
    allPTDatas.allData &&
    Object?.entries(allPTDatas.allData)
      ?.sort(([keyA], [keyB]) => {
        const indexA = PT_MEMBERS_INFO_ORDER.indexOf(keyA);
        const indexB = PT_MEMBERS_INFO_ORDER.indexOf(keyB);

        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      })
      ?.map(([key, value], index) => (
        <React.Fragment key={index}>
          <CommonStatCard
            tagName={key}
            cardLabel={getCardLabel(key, isDateSelected)}
            value={getCardValue(key, value || 0)}
            icon={getCardIcon(key, loading)}
            onClickCard={onClickStatCard}
          />
        </React.Fragment>
      ));

  return (
    <div className="flexCol">
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "export_data" ? "mod-width-50p" : ""
          }`}
        >
          <ModalHeadAndClose
            title={`${getCardLabel(modValues.modName)}`}
            onClose={onCloseModal}
          />

          {
            // modValues.modName === "export_data" ? (
            //   <SelectExportables
            //     name={"pt-flow-taee"}
            //     exportableData={taeeExportable}
            //     filters={prevFilters}
            //     callFunction={onClickExport}
            //     isLoadingCSV={exportLoading}
            //     csvData={csvData}
            //     setCsvData={setCsvData}
            //   />
            // ) :
            <PTFlowStatCardDetails
              userInfoData={userInfoData}
              clickedCard={modValues.modName}
              prevAllFilters={prevAllFilters}
            />
          }
        </div>
      </Modal>

      <MealsStructure
        text={"PT Members info"}
        isReload={combineReload}
        // isExport={true}
        // onClickExportBtn={() => {
        //   setModValues((prevs) => ({
        //     ...prevs,
        //     isModOpen: true,
        //     modName: "export_data",
        //   }));
        // }}
      />

      <div className="cards-container cards-grid-container grid-5 pt-flow-new">
        {sortedCards}
      </div>
    </div>
  );
};

export default PTFlowStats;
